import apiAthleteScholarship from '@/api/athlete-scholarship'

const state = {
  data: [],
  isLoading: false,
  error: null
}

export const mutationTypes = {
  getAthleteScholarshipStart:
    '[athletes scholarship] Get athletes scholarship start',
  getAthleteScholarshipSuccess:
    '[athletes scholarship] Get athletes scholarship success',
  getAthleteScholarshipFailure:
    '[athletes scholarship] Get athletes scholarship failure'
}

export const actionTypes = {
  getAthleteScholarship: '[athletes scholarship] Get athlete scholarship'
}

const mutations = {
  [mutationTypes.getAthleteScholarshipStart](state) {
    state.isLoading = true
    state.error = null
    state.data = []
  },

  [mutationTypes.getAthleteScholarshipSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getAthleteScholarshipFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  }
}

const actions = {
  [actionTypes.getAthleteScholarship](context) {
    context.commit(mutationTypes.getAthleteScholarshipStart)
    return new Promise(resolve => {
      apiAthleteScholarship
        .getAthletesScholarship()
        .then(response => {
          context.commit(
            mutationTypes.getAthleteScholarshipSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(error => {
          context.commit(mutationTypes.getAthleteScholarshipFailure, error)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
